import { render, staticRenderFns } from "./BalanceChange.vue?vue&type=template&id=56e4a6cc&scoped=true&"
import script from "./BalanceChange.vue?vue&type=script&lang=js&"
export * from "./BalanceChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4a6cc",
  null
  
)

export default component.exports